import { useState, useEffect } from 'react';
import { fetchFooter } from '../services/strapi';
const Footer = () => {
  const [footer, setFooter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getFooter = async () => {
      try {
        setLoading(true);
        const data = await fetchFooter(); 
        console.log("Fetched Footer Data:", data); 
        setFooter(data); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getFooter();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  return (
    <div className="footer">
      {footer && (
           <footer>
                <div className='footerLogo'>
                    <img src='/classicTheCity.svg' className="app-logo" alt="logo" />
                </div>
                <div className='siteInformation'>
                    <ul>
                        <li>{footer.OpenTime}</li>
                        <li>{footer.Email}</li>
                        <li>{footer.Telephone}</li>
                        <li>{footer.Address}</li>
                    </ul>
                   
                </div>
            
                    <div className="socialLinks">
                    {footer.SocialLinks && footer.SocialLinks.length > 0 && (
                    <ul>
                        {footer.SocialLinks.map((link) => (
                        <li key={link.id}>
                            <a href={link.LinkUrl} target="_blank" rel="noopener noreferrer">
                            {link.LinkText}
                            </a>
                        </li>
                        ))}
                    </ul>
                    )}
                </div>

                <div className="serviceLinks">
                    {footer.ServiceLinks && footer.ServiceLinks.length > 0 && (
                    <ul>
                        {footer.ServiceLinks.map((service) => (
                        <li key={service.id}>
                            <a href={service.LinkText} target="_blank" rel="noopener noreferrer">
                            {service.LinkTitle}
                            </a>
                        </li>
                        ))}
                    </ul>
                    )}
                </div>
                {footer.copyright}
           </footer>

        )}
    </div>
  );
};

export default Footer;
